import { Component, OnInit, EventEmitter, Input, Output, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { SelectItem } from 'primeng/api';
import { ProviderManagementService } from '@core/service';
import { ProviderAccountPgpsDTO } from '@mynexus/mynexus-ui-lib';

@Component({
    selector: 'app-service-provider-search',
    templateUrl: './service-provider-search.component.html',
    styleUrls: ['./service-provider-search.component.scss'],
    standalone: false
})
export class ServiceProviderSearchComponent implements OnInit, OnDestroy {
  @Input() tenantId: string;
  @Input() label = '';
  @Input() npiNotFound = false;
  @Input() isProviderNotFound: boolean;
  @Input() authRequest: boolean;

  @Output() serviceProviderSelected = new EventEmitter<
    ProviderAccountPgpsDTO[]
  >();
  @Output() npiNotFoundChange = new EventEmitter<boolean>();
  @Output() isProviderNotFoundChange = new EventEmitter<boolean>();

  isExternalUser: boolean;
  isLoading = false;
  searchText: string;

  searchForm: FormGroup;
  providerSelectionForm: FormGroup;
  npiCheck = new FormControl();

  selectedProvider: ProviderAccountPgpsDTO;
  availableProviders: SelectItem[] = [];

  subs = new SubSink();

  constructor(private providerManagementService: ProviderManagementService) {}

  ngOnInit() {
    this.setDefaultValues();
    this.buildForms();
    this.searchFormWatch();

    if (this.npiNotFound) {
      this.npiCheck.setValue(this.npiNotFound);
    }
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  buildForms() {
    this.buildSearchForm();
    this.buildSelectionForm();
  }

  buildSearchForm() {
    this.searchForm = new FormGroup({
      searchText: new FormControl('', [
        Validators.required,
        Validators.minLength(10),
      ]),
    });
    this.checkboxWatch();
  }

  buildSelectionForm() {
    this.providerSelectionForm = new FormGroup({
      selectedProvider: new FormControl([]),
    });
  }

  setDefaultValues() {
    this.searchText = '';
    this.availableProviders = [];
    this.npiCheck.setValue(null);
  }

  updateStatus(event) {
    this.npiNotFoundChange.emit(event.checked);
  }

  searchFormWatch(): void {
    this.subs.sink = this.searchForm.valueChanges.subscribe((val) => {
      this.searchText = val.searchText;
    });
  }

  checkboxWatch() {
    this.subs.sink = this.npiCheck.valueChanges.subscribe((res) =>
      this.npiNotFoundChange.emit(res)
    );
  }

  searchNPI() {
    this.isLoading = true;
    this.npiCheck.setValue(null);

    this.providerManagementService
      .getActiveProviderAccountPgpsByNpi(this.searchText, this.tenantId)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((resp) => {
        this.serviceProviderSelected.emit(resp);

        const providerNotFound = !resp?.length;

        this.isProviderNotFoundChange.emit(providerNotFound);
        this.isProviderNotFound = providerNotFound;
      });
  }
}
